import React from 'react';
import { Board } from '../components/Board';
import { Coalition } from '../components/Coalition';
import { Commitments } from '../components/Commitments';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Issues } from '../components/Issues';
import { JoinCoalition } from '../components/JoinCoalition';
import { Mission } from '../components/Mission';
import { Navbar } from '../components/Navbar';
import { News } from '../components/News';
import { Seo } from '../components/Seo';
import { Stats } from '../components/Stats';
export function Home() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-293" data-mp="29i7xxy5ovyej">
      <Seo title="Arizona Local Voices & Local Decision-Making" description="Arizona is not one community — it is hundreds. AZ City PAC stands with leaders who listen to communities, collaborate across sectors, and protect local decision-making." schema={{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'AZ City PAC',
      url: 'https://azcitypac.com',
      description: 'A statewide coalition protecting local decision-making and advancing policies that strengthen Arizona cities and towns.',
      about: ['Arizona local voices', 'local decision-making', 'municipal leadership', 'growth and land use', 'safe neighborhoods', 'strong local economies', 'accountable government']
    }} data-id="element-294" data-mp="2dirtixam6tyk" />
      <Navbar data-id="element-295" data-mp="287cg1w84iem9" />

      <main className="flex-grow" data-id="element-296" data-mp="288vwbmts4po1">
        <Hero data-id="element-297" data-mp="28618dlbk4mpv" />
        <Stats data-id="element-298" data-mp="23916znpnk853" />
        <Mission data-id="element-299" data-mp="239j9v36tlklz" />
        <Commitments data-id="element-300" data-mp="23a2i1s6o4umt" />
        <Issues data-id="element-301" data-mp="23am15c821p2f" />
        <Coalition data-id="element-302" data-mp="236y78byp70n6" />
        <JoinCoalition data-id="element-303" data-mp="1z7ftq197hrud" />
        <Board data-id="element-304" data-mp="1z7pdh73nr2rm" />
        <News data-id="element-305" data-mp="1z64hre5lxds6" />
        <FinalCTA data-id="element-306" data-mp="1z6wa8g3wqve8" />
      </main>

      <Footer data-id="element-307" data-mp="1u8cpuk4yprnz" />
    </div>;
}